import React from "react";
import ProductCard from "../components/ProductCard";
import { Product } from "../interfaces/home_entity";

interface TopRatedProductsProps {
  products: Product[];
}

const TopRatedProducts: React.FC<TopRatedProductsProps> = ({ products }) => (
  <div className="right-section">
    <h3>⭐ Top Rated Products</h3>
    <div className="product-grid small-grid">
      {products.slice(-4).map((product) => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  </div>
);

export default TopRatedProducts;
